export enum Routes {
  login = "signin",
  register = "signup",
  user = "user",
  users = "users",
  permissions = "permissions",
  admins = "profiles/admins",
  supervisors = "profiles/supervisors",
  parents = "profiles/parents",
  students = "profiles/students",
  tutors = "profiles/tutors",
  assistants = "profiles/assistants",
  contenters = "profiles/contenters",
  error404 = "error/404",
  error500 = "error/500",
}
